import { NgModule} from '@angular/core';
import { MaterialModule,MdTabsModule } from '@angular/material';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { RequestsRoutingModule } from './viewrequests-routing.module';
import { viewRequestsComponent } from './viewrequests.component';
import { viewRequestAddComponent , viewDialog} from './create/create.component';
import { viewRequestReturnComponent } from './return/return.component';
import { viewRequestConfirmComponent } from './confirm/confirm.component';
import { FileUploadModule } from '../fileUpload.module';
import { SOCDetailsModule } from '../socIdDetails/socIdDetails.module';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { TranslateLoader, TranslateModule, TranslateStaticLoader } from 'ng2-translate';
import { Http } from '@angular/http';

@NgModule({
    imports: [
        MaterialModule,
        MdTabsModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RequestsRoutingModule,
        FileUploadModule,
        SOCDetailsModule,
        PdfViewerModule,
        TranslateModule
    ],
    declarations: [
        viewRequestsComponent,
        viewRequestAddComponent,
        viewRequestReturnComponent,
        viewRequestConfirmComponent,
        viewDialog
    ],
    entryComponents: [viewDialog],
    
    exports: [
        TranslateModule
    ]
})

export class viewRequestsModule {}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/viewRequest/viewrequests.module.ts